import styled from "styled-components";

export const Wrapper = styled.div`

    .pagination-table {
        width: 100%;
        display: flex;
        align-item: center;
        justify-content: flex-end;
        padding-top: 20px;
        padding-bottom: 20px;
    }
`;


export const TableHeading = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;

    .title {
        font-size: 13px;
        color: white;
    }
`

export const TableContent = styled.div`
    font-size: ${props => props.font ? "12px" : "13px"};
    text-align: ${props => props.left ? "left" : "center"};
    text-transform: ${props => props.lowercase ? "lowercase" : "capitalize"};
    ${props => props.line ? "line-height: 1rem;" : ""}
    ${props => props.minWidth ? "min-width: 210px;" : ""}
`
